import { type vInput, vObject, vPicklist } from '../validation/index.ts'
import type { CarrierType } from './carrier.ts'

export interface CarrierDuplicateSummary {
  _id: string
  name: string
  carrierType: CarrierType
  spotUserCount: number
  accountCount: number
  emailDomains: string[]
}

export interface DuplicateGroup {
  matchedCarrierId: string
  matchedName: string
  count: number
  mostRecentEntryDate: string
}

export interface DuplicateCarrierEntry extends CarrierDuplicateSummary {
  entryId: string
  confidence: number
  createdAt: string
}

export interface DuplicateGroupDetail {
  matchedCarrier: CarrierDuplicateSummary
  duplicates: DuplicateCarrierEntry[]
}

const duplicateMatcherTypes = ['email', 'name'] as const
export type DuplicateMatcherType = (typeof duplicateMatcherTypes)[number]

export const detectDuplicatesSchema = vObject({
  matcher: vPicklist(duplicateMatcherTypes),
})

export type DetectDuplicatesDto = vInput<typeof detectDuplicatesSchema>

const bulkDuplicateActions = ['merge', 'dismiss'] as const
export type BulkDuplicateAction = (typeof bulkDuplicateActions)[number]

export const bulkDuplicateActionSchema = vObject({
  action: vPicklist(bulkDuplicateActions),
})
export type BulkDuplicateActionRequest = vInput<
  typeof bulkDuplicateActionSchema
>

export interface BulkDuplicateActionResponse {
  count: number
}
